import api from './api';

export const exportProductsToCSV = async () => {
  try {
    const response = await api.get('/products/export/csv', {
      responseType: 'blob'
    });
    
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error exporting products:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Error exporting products'
    };
  }
};